import React from "react";
import "../Content/Content.css";
import Overview from "../Overview/Overview";
import Announcement from "../Announcement/Announcement";
import Circular from "../Circular/Circular";
import Eventlist from "../Eventlist/Eventlist";
import AttendanceChart from "../AttendanceChart/AttendanceChart";

function Content() {
  return (
    <div className="content">
      <div className="content-top">
        <Overview />
      </div>
      <div className="content-mid">
        
          <AttendanceChart />
        
      </div>
      <div className="content-bottom">
        <div className="content-section announcements">
          <Announcement />
        </div>
        <div className="content-section circular">
          <Circular />
        </div>
        <div className="content-section events">
          <Eventlist />
        </div>
      </div>
    </div>
  );
}

export default Content;